<template>
<v-container>
  <!-- BOC:[breadcrumbs] -->
  <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
  <!-- EOC -->
  <!-- BOC:[error] -->
  <AError :api="api"></AError>
  <!-- EOC -->
  <v-card>
    <v-card-title>{{$t("action.delete")}}{{($_getLocale() == 'zh')?'':' '}}{{$t("model.name." + this.model.name.singular.toLowerCase())}}</v-card-title>
    <v-card-text>
      <!-- BOC:[alert] -->
      <v-alert
        border="bottom"
        colored-border
        type="error"
        elevation="2"
      >
        This action is irreversible. Are you sure you want to delete <b>{{(me.name) ? me.name : `${model.name.singular} ${$route.params.id}`}}</b>?
      </v-alert>
      <!-- EOC -->
      <!-- BOC:[form] -->
      <div class="text-right">
        <v-btn
          color="error"
          class="mr-4"
          @click="submit"
          text
        >
           {{$t("action.yes")}}
        </v-btn>
        <v-btn
          text
          @click="$router.go(-1)"
        >
          {{$t("action.no")}}
        </v-btn>
      </div>
      <!-- EOC -->
    </v-card-text>
  </v-card>
</v-container>
</template>

<script>
  //BOC:[model]
  import model from '@/models/items/festival'
  //EOC
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'self',
    ],
    data: () => ({
      //BOC:[role]
      role:'Moderator',
      //EOC
      //BOC:[model]
      model: model,
      //EOC
      //BOC:[breadcrumbs]
      breadcrumbs: [],
      //EOC
      //BOC:[api]
      api:{
        isLoading:false,
        isError:false,
        error:null,
        url:null,
      },
      //EOC
      //BOC:[self]
      me:{
        id:null,
      },
      //EOC
      //BOC:[form]
      form: {},
      //EOC
    }),
    created() {
      //BOC:[guard]
      if(!this.model[this.role].delete) {
        this.$router.replace(this.$_getRouteRead(this.role,this.model.key,this.$route.params.id,this.self))
        return
      }
      //EOC
      //BOC:[self]
      if(this.self) this.me = this.$_.cloneDeep(this.self)
      //EOC
      //BOC:[breadcrumbs]
      this.breadcrumbs.push({
        text:this.$t("model.name.dashboard"),
        to:{name:'Page'+this.role+'Dashboard'},
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:this.$t("model.name." + this.model.name.plural.toLowerCase()),
        to:this.$_getRouteBrowse(this.role,this.model.key),
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:(this.me.name) ? this.me.name : `${this.$t("model.name." + this.model.name.singular.toLowerCase())} ${this.$route.params.id}`,
        to:this.$_getRouteRead(this.role,this.model.key,this.$route.params.id,this.self),
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:this.$t("action.delete"),
        to:this.$_getRouteDelete(this.role,this.model.key,this.$route.params.id,this.self),
        exact:true,
      })
      //EOC
      //BOC:[url]
      this.api.url = `${this.$api.servers.moderator}/v1/school/${this.school.id}/festival/delete`
      //EOC
      //BOC:[api]
      this.api.callbackReset = () => {
        this.api.isLoading = true
        this.api.isError = false
        this.api.error = null
      }
      this.api.callbackError = (e) => {
        this.api.isLoading = false
        this.api.isError = true
        this.api.error = e
      }
      this.api.callbackSuccess = () => {
        this.api.isLoading = false
        this.$router.push(this.$_getRouteBrowse(this.role,this.model.key))
      }
      //EOC
      //BOC:[form]
      this.form.id = this.$route.params.id
      //EOC
    },
    mounted() {
      //
    },
    methods: {
      //BOC:[form]
      submit() {
        this.api.params = this.$_.clone(this.form)
        this.$api.fetch(this.api)
      },
      //EOC
    }
  }
</script>